/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Custompagedisplayname3Inputs */

const en_entity_custompagedisplayname3 = /** @type {(inputs: Entity_Custompagedisplayname3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Custom Page Display Name`)
};

const de_entity_custompagedisplayname3 = /** @type {(inputs: Entity_Custompagedisplayname3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Angezeigter Name`)
};

/**
* | output |
* | --- |
* | "Custom Page Display Name" |
*
* @param {Entity_Custompagedisplayname3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_custompagedisplayname3 = /** @type {((inputs?: Entity_Custompagedisplayname3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Custompagedisplayname3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_custompagedisplayname3(inputs)
	return de_entity_custompagedisplayname3(inputs)
});
export { entity_custompagedisplayname3 as "entity_customPageDisplayName" }